import React from "react";
import { Button } from "react-bootstrap";
function PromptPreview({ responseData }) {
  var resData = responseData.split("\n");
  return (
    <>
      <div className="prompt-preview-container d-flex justify-content-center align-items-center">
        <div className="prompt-preview mb-5">
          <h5>ANSWERS:</h5>
          {resData.map((data, index) => {
            return(
              <span key={index}>{data}<br/></span>
            )
          })}
          <Button
            className="mt-4"
            variant="success"
            onClick={() => window.location.reload(true)}
          >
            New Request
          </Button>
        </div>
      </div>
    </>
  );
}

export default PromptPreview;
